import { useCallback, useEffect, useRef } from 'react';

import { useEvent } from 'react-use';

import { useChartContext } from '@/components/Chart/context/ChartContext';
import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';

const useRegularChart = ({
  chartSeries
}: {
  chartSeries: ExtendedSeriesOptionsType[] | undefined;
}) => {
  const timeoutRef = useRef<NodeJS.Timeout>(null);
  const chartContainerRef = useRef<HTMLDivElement>(null);

  const { setChartSeries, chartRef } = useChartContext();

  const handleResize = useCallback(() => {
    const chart = chartRef.current?.chart;
    const container = chartContainerRef.current;

    if (!chart || !container) return;

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      chart.container.style.display = 'none';
      chart.setSize(container.getBoundingClientRect().width);
      chart.container.style.display = 'block';
    }, 100);
  }, [chartRef]);

  useEvent('resize', handleResize, window);

  useEffect(() => {
    setChartSeries(chartSeries);
  }, [chartSeries, setChartSeries]);

  return { chartContainerRef };
};

export default useRegularChart;
